import { BACK, LAY } from '../strings';

export const ONE_DAY_TEEN_PATTI_BET_TYPES = {
  // MAIN BETS
  PLAYER_A: 'PlayerA',
  PLAYER_B: 'PlayerB',

  // SIDEBETS
  ONE_PAIR: 'OnePair',
  STRAIGHT_FLUSH: 'StraightFlush',
  THREE_OF_A_KIND: 'ThreeOfAKind',
  STRAIGHT: 'Straight',
  FLUSH: 'Flush',

  // bet types for BACK & LAY
  PLAYER_A_BACK: `PlayerA_${BACK}`,
  PLAYER_A_LAY: `PlayerA_${LAY}`,
  PLAYER_B_BACK: `PlayerB_${BACK}`,
  PLAYER_B_LAY: `PlayerB_${LAY}`,
};
